import { css } from '@emotion/core'
import { colors, measures, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

export const container = css`
  display: flex;
  padding: ${spacing(0, 5)};
  align-items: center;
  justify-content: space-between;
  gap: ${spacing(2.5)};
  background-color: ${colors.grays.gray8};
  height: ${spacing(12.25)};
  z-index: 2;
  
  ${MQ.PHONES} {
    display: none;
  }
  
  ${MQ.TABLETS} {
    display: none;
  }
  
  ${MQ.DESKTOPS} {
    right: 0;
    left: 0;
    position: relative;
    height: ${spacing(12.25)};
    width: 100%;
    padding: ${spacing(0, 5)};
    box-sizing: border-box;
  }
`

export const menu = css`
  list-style: none;

  li {
    color: ${colors.white100};

    display: inline-block;

    margin: 0 ${2 * unit}px;

    white-space: nowrap;

    cursor: pointer;
  }

  li:hover {
    color: ${colors.grays.gray2};
  }
`

export const logo = css`
  height: ${2 * unit}px;
  width: ${3 * unit}px;
`

export const left = css`
  display: flex;
  align-items: center;
`

export const titleText = css`
  ${MQ.PHONES} {
    max-width: 16ch;
  }
`

export const triggerText = css`
  vertical-align: middle;
`

export const triggerIcon = css`
  color: ${colors.white100};
  :hover {
    color: ${colors.greens.green6};
  }
`

export const textNearLogo = css`
  ${MQ.PHONES} {
    display: none;
  }
`

export const text = css`
  :hover {
    color: ${colors.greens.green6};
  }
`

export const MenuDrop = css`
  ${MQ.PHONES} {
    display: none;
  }
`

export const FirstMenuDrop = css`
  ${MQ.NOT_PHONES} {
    display: none;
  }
`

export const MenuHeader = css`
  display: flex;
  align-items: center;
  justify-content: center;
  ${MQ.DESKTOPS} {
    display: none;
  }
`
export const BurgerMenu = css`
  cursor: pointer;
  margin-right: ${spacing(2)};
`

export const heading = css`
  display: block;
  & img {
    display: block;
  }
`

export const buttonContainer = css`
  display: flex;
  gap: ${spacing(1)};
  align-items: center;
  
  ${MQ.PHONES} {
    button {
      font-size: 14px;
      padding: 6px 16px !important;
      height: 32px !important;
      border-radius: 30px !important;
    }
  }

  @media (min-width: 360px) and (max-height: 740px) {
    button {
      padding: 4px 12px !important;
      height: 28px !important;
      font-size: 13px !important;
    }
  }

  @media (max-width: 345px) and (min-height: 880px) {
    button {
      padding: 4px 10px !important;
      height: 26px !important;
      font-size: 12px !important;
    }
  }
`
